import React from 'react';
import { Check, ChevronDown } from 'lucide-react';
import { TIPOS, TIPOS_PREGUNTA } from '../../../lib/formularios';
import {
  DropdownMenu, DropdownMenuContent, DropdownMenuItem, DropdownMenuSeparator, DropdownMenuTrigger,
} from '../../ui/dropdown-menu';
import { ICONOS_TIPO } from './contexto';

/** Selector del tipo de pregunta, agrupado con separadores como el de Google Forms. */
export default function SelectorTipo({ tipo, onCambiar, disabled }) {
  const Icono = ICONOS_TIPO[tipo];
  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild disabled={disabled}>
        <button type="button" className="fe-selector-tipo" aria-label={`Tipo de pregunta: ${TIPOS[tipo]?.nombre}`}>
          {Icono && <Icono />}
          <span className="fe-selector-tipo-texto">{TIPOS[tipo]?.nombre}</span>
          <ChevronDown className="fe-selector-tipo-flecha" />
        </button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end" className="fe-menu fe-menu-tipos">
        {TIPOS_PREGUNTA.map((t, i) => {
          const IconoT = ICONOS_TIPO[t];
          const nuevoGrupo = i > 0 && TIPOS[TIPOS_PREGUNTA[i - 1]].grupo !== TIPOS[t].grupo;
          return (
            <React.Fragment key={t}>
              {nuevoGrupo && <DropdownMenuSeparator />}
              <DropdownMenuItem onSelect={() => t !== tipo && onCambiar(t)} className={t === tipo ? 'is-activo' : ''}>
                <IconoT />
                <span className="flex-1">{TIPOS[t].nombre}</span>
                {t === tipo && <Check className="fe-menu-check" />}
              </DropdownMenuItem>
            </React.Fragment>
          );
        })}
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
